module.exports = __webpack_public_path__ + "img/icon-implantation-03.0b435932.svg";